import React from "react";
import { useState } from "react";
import './TicketUpdateForm.css'

const TicketUpdateForm = () => {
    const [formData, setFormData] = useState({
      category: '',
      subcategory: '',
      priority: '',
      assignedAgent: ''
    });
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    };
  
    return (
      <div className="ticket-update-card">
                    <h2>Update Ticket</h2>
                    <form className="update-form" onSubmit={(e) => e.preventDefault()}>
                      <div className="form-group">
                        <label>Category</label>
                        <select 
                          name="category" 
                          value={formData.category} 
                          onChange={handleInputChange}
                        >
                          <option value="">Select Category</option>
                          <option value="technical">Technical</option>
                          <option value="billing">Billing</option>
                          <option value="support">Support</option>
                        </select>
                      </div>
                      
                      <div className="form-group">
                        <label>Subcategory</label>
                        <select 
                          name="subcategory" 
                          value={formData.subcategory} 
                          onChange={handleInputChange}
                        >
                          <option value="">Select Subcategory</option>
                          <option value="performance">Performance</option>
                          <option value="security">Security</option>
                          <option value="usability">Usability</option>
                        </select>
                      </div>
                      
                      <div className="form-group">
                        <label>Priority</label>
                        <select 
                          name="priority" 
                          value={formData.priority} 
                          onChange={handleInputChange}
                        >
                          <option value="">Select Priority</option>
                          <option value="low">Low</option>
                          <option value="medium">Medium</option>
                          <option value="high">High</option>
                          <option value="critical">Critical</option>
                        </select>
                      </div>
                      
                      <div className="form-group">
                        <label>Assigned Agent</label>
                        <select 
                          name="assignedAgent" 
                          value={formData.assignedAgent} 
                          onChange={handleInputChange}
                        >
                          <option value="">Select Agent</option>
                          <option value="sarah-smith">Sarah Smith</option>
                          <option value="john-doe">John Doe</option>
                          <option value="mike-johnson">Mike Johnson</option>
                        </select>
                      </div>
                      
                      <button type="submit" className="update-button">Update Ticket</button>
                    </form>
                  </div>
    );
  };

export default TicketUpdateForm;